<mat-form-field appearance="outline" class="col-12">
    <mat-label>MM / YY</mat-label>
    <input [type]="fieldObject.fieldType"
           class="form-control"
           [formControl]="formControlRef"
           (keyup)="dateFormat()"
           maxlength="7"
           #ccDate
           matInput
           id="card-expiration"
           [name]="fieldObject.autoCompleteName"
           [autocomplete]="fieldObject.autoCompleteName">
    <mat-error *ngIf="fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName]">
      {{ fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName] }}
    </mat-error>
  </mat-form-field>
